<template>
  <div class="box">
    <van-form>
      <van-field v-model="info.userName" disabled name="被保险人姓名" label="被保险人姓名" placeholder="被保险人姓名" :rules="[{ required: true, message: '请填写被保险人姓名' }]" />
      <van-field v-model="info.userIdCard" disabled name="身份证号/组织机构代码" label="身份证号/组织机构代码" placeholder="身份证号/组织机构代码" :rules="[{ required: true, message: '请填写身份证号/组织机构代码' }]" />
      <van-field v-model="info.phone" disabled name="联系方式" label="联系方式" placeholder="联系方式" :rules="[{ required: true, message: '请填写联系方式' }]" />
      <van-field v-model="info.policyholder" disabled name="投保人" label="投保人" placeholder="投保人" :rules="[{ required: true, message: '请填写投保人' }]" />
      <van-field v-model="info.area" disabled name="保险数量（亩/株）" label="保险数量（亩/株）" placeholder="保险数量（亩/株）" :rules="[{ required: true, message: '请填写保险数量（亩/株）' }]" />
      <van-field v-model="info.premium" disabled name="自交保险费" label="自交保险费" placeholder="自交保险费" :rules="[{ required: true, message: '请填写农户自交保险费' }]" />
      <van-field name="uploader" required label="保单资料" placeholder="请上传已签署的保单资料" :rules="[{ required: true, message: '请上传已签署的保单资料' }]">
        <template #input>
          <div class="upload-section">
            <van-uploader v-model="fileList" accept="image/*" :max-count="2" :after-read="afterRead" class="custom-uploader" upload-text="上传图片">
              <div class="upload-placeholder">
                <van-icon name="photograph" size="24" color="#E99D42" />
                <div class="upload-text">点击上传保单资料</div>
                <div class="upload-hint">支持JPG、PNG格式</div>
              </div>
            </van-uploader>
            <div class="download-section">
              <div class="download-text">
                <van-icon name="down" size="16" color="#E99D42" />
                请先下载
              </div>
              <div class="download-text"><span class="download-link" @click="handleDownloadFile">《保单签署资料》</span></div>
              <div class="download-text">签署扫描或拍照后上传正反面图片</div>
            </div>
          </div>
        </template>
      </van-field>
      <div class="tips">
        <van-checkbox v-model="checked" icon-size="18px" checked-color="#E99D42"
          >确认信息前请阅读<span style="color: #e99d42;" @click.stop="gotoArticle1">《低温指数保险条款》</span><span style="color: #e99d42;" @click="gotoArticle2">《热带气旋风力指数保险条款》</span><span style="color: #e99d42;" @click="gotoAgreement">《服务协议》</span></van-checkbox
        >
      </div>
      <div class="confirm">
        <van-button class="confirm-btn" color="#E99D42" @click="handleSub()">
          确认提交
        </van-button>
      </div>
    </van-form>
    <van-popup v-model="show" :style="{ height: '100%' }" :close-on-click-overlay="false">
      <div class="choose-box">
        <div class="title">请选择需要申报信息的保单</div>
        <div class="item" v-for="(item, index) in this.insuranceList" :key="item.policyholder" @click="handleClickInsurance(index)">{{ item.batchName + ' ' + item.policyholder }}<span v-if="item.isCompleted == 1">(已提交)</span><span v-if="item.isCompleted == 0">(未提交)</span></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { uploadFile } from '@/service/upload'
import { getTeamInfoByIdcard, genUesrInfo, submitTeamForm } from '@/service/insurance'
export default {
  props: {},
  data() {
    return {
      insuranceList: [],
      show: false,
      fileList: [],
      info: {
        userName: '',
        idcard: '',
        phone: '',
        // address: '',
        area: '',
        premium: '',
        name: '',
        bankNumber: '',
        prephone: ''
      },
      form: {
        userId: '', // 保单用户id
        insuranceApplicationFile: '' // 文件地址
      },
      checked: false
    }
  },
  mounted() {
    genUesrInfo().then((res) => {
      console.log(res.data, 'res.data')
      console.log(res.data.user.nickName, 'res.data.user.nickName')
      sessionStorage.setItem('idcard', res.data.user.userIdCard)
      // 根据身份证获取保单信息,如果数量超过1则需要选择
      getTeamInfoByIdcard(sessionStorage.getItem('idcard')).then((res) => {
        this.insuranceList = res.data
        if (this.insuranceList.length == 1) {
          if (this.insuranceList[0].isCompleted == 1) {
            this.$toast.fail('该项目已完成申报！')
            this.$router.replace('/team/team-login')
            return false
          }
          this.form = {
            userId: this.insuranceList[0].userId,
            insuranceApplicationFile: '' // 文件地址
          }
          this.info = {
            userName: this.insuranceList[0].userName,
            userIdCard: this.insuranceList[0].userIdCard,
            phone: this.insuranceList[0].phone,
            policyholder: this.insuranceList[0].policyholder,
            area: this.insuranceList[0].insuranceAcreage,
            premium: this.insuranceList[0].paymentAmount + '元',
            name: '',
            bankNumber: '',
            prephone: ''
          }
          this.userId = this.insuranceList[0].userId
        } else {
          this.show = true
        }
      })
    })
  },
  methods: {
    // 判断是否是微信安卓环境
    isWeChatAndroid() {
      const ua = navigator.userAgent
      return /MicroMessenger/i.test(ua) && /Android/i.test(ua)
    },
    handleDownloadFile() {
      if (!this.form.userId) {
        this.$toast.fail('请先选择保单')
        return
      }

      // 显示下载提示
      this.$toast.loading({
        message: '正在生成文件...',
        forbidClick: true,
        duration: 0
      })

      // 调试信息
      console.log('开始下载文件，用户ID:', this.form.userId)
      console.log('当前认证token:', sessionStorage.getItem('Authorization'))

      // 直接使用fetch获取文件数据
      this.downloadFileDirectly()
    },

    // 直接下载文件方法
    async downloadFileDirectly() {
      const baseURL = process.env.VUE_APP_BASE_API
      const token = sessionStorage.getItem('Authorization')

      try {
        const response = await fetch(`${baseURL}/business/userInsuranceList/exportWord/${this.form.userId}`, {
          method: 'POST',
          headers: {
            Authorization: token || '',
            'Content-Type': 'application/json',
            Clientid: '428a8310cd442757ae699df5d894f051'
          },
          body: JSON.stringify({})
        })

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`)
        }

        // 获取文件数据
        const blob = await response.blob()

        // 判断是否是微信浏览器以及安卓手机
        if (this.isWeChatAndroid()) {
          console.log('微信安卓')
          // 上传文件到oss
          // blob转file
          let file = this.blobToFile(blob, '保单签署资料.docx')
          let formData = new FormData()
          formData.append('file', file, '保单签署资料.docx')
          uploadFile(formData)
            .then((res) => {
              this.$toast.clear()
              this.$toast.success('文件下载成功')
              const link = document.createElement('a')
              link.href = res.data.url
              link.download = '保单签署资料.docx'
              link.style.display = 'none'
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
            })
            .catch((error) => {
              this.$toast.clear()
              this.$toast.fail(`文件下载失败: ${error.message}`)
            })
          return
        }

        // 创建下载链接
        const url = URL.createObjectURL(blob)
        // window.open(url, '_blank')
        const link = document.createElement('a')
        link.href = url
        link.download = '保单签署资料.docx'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        // 清理URL
        setTimeout(() => {
          URL.revokeObjectURL(url)
        }, 1000)

        this.$toast.clear()
        this.$toast.success('文件下载成功')
      } catch (error) {
        console.error('直接下载失败:', error)
        this.$toast.clear()
        this.$toast.fail(`文件下载失败: ${error.message}`)
      }
    },
    handleClickInsurance(index) {
      console.log(index, 'index')
      this.form = {
        userId: this.insuranceList[index].userId,
        userName: this.insuranceList[index].userName,
        frontSideOfIdCard: '', // 身份证正面
        backSideOfIdCard: '', // 身份证反面
        bankCard: this.insuranceList[index].bankCard, // 银行卡号
        bankOfDeposit: this.insuranceList[index].bankOfDeposit, // 开户行
        cardholderIdCard: this.insuranceList[index].userIdCard, // 持卡人身份证
        frontSideOfBankCard: '', // 银行卡正面
        backSideOfBankCard: '', // 银行卡反面
        signaturePhoto: '' // 签名照片
      }
      this.info = {
        userName: this.insuranceList[index].userName,
        userIdCard: this.insuranceList[index].userIdCard,
        phone: this.insuranceList[index].phone,
        policyholder: this.insuranceList[index].policyholder,
        area: this.insuranceList[index].insuranceAcreage,
        premium: this.insuranceList[index].paymentAmount + '元',
        name: '',
        bankNumber: '',
        prephone: ''
      }
      if (this.insuranceList[index].isCompleted == 1) {
        this.$toast.fail('该项目已完成申报！')
        return false
      }
      this.show = false
    },
    handleSub() {
      // 处理图片
      this.form.insuranceApplicationFile = this.fileList.map((item) => item.url).join(',')
      submitTeamForm(this.form)
        .then((res) => {
          console.log(res)
          this.$toast.success('提交成功')
          setTimeout(() => {
            this.$router.replace('/team/finished')
          }, 1000)
        })
        .catch((err) => {
          this.$toast.fail(err.msg || err.message || err || '提交失败')
        })
    },
    gotoArticle1() {
      this.$router.push('/article1')
    },
    gotoArticle2() {
      this.$router.push('/article2')
    },
    gotoAgreement() {
      this.$router.push('/agreement')
    },
    // beforeRead(file) {
    //   if (file.type !== 'image/') {
    //     this.$toast('请上传图片')
    //     return false
    //   }
    // },
    afterRead(file) {
      let fileArr = []
      if (Array.isArray(file)) {
        // 多个文件
        fileArr = file
      } else {
        // 单个文件
        fileArr = [file]
      }
      for (let i = 0; i < fileArr.length; i++) {
        const fileItem = fileArr[i]
        this.preUpload(fileItem)
      }
    },
    preUpload(fileItem) {
      this.fileStatusSet(fileItem, 'uploading', '上传中...')
      let img = new Image()
      img.src = fileItem.content
      img.onload = () => {
        //压缩图片
        let imgName = fileItem.file.name
        let fileOrigin = fileItem
        this.compressImg(img, imgName, fileOrigin)
      }
    },
    //将base64转换为blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    //将blob转换为file
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    fileStatusSet(fileOrigin, status, message, url) {
      fileOrigin.url = url
      fileOrigin.status = status
      fileOrigin.message = message
    },
    //压缩图片并上传
    compressImg(img, imgName, fileOrigin) {
      let originWidth = img.width, // 压缩后的宽
        originHeight = img.height,
        maxWidth = 1000,
        // maxHeight = 1000, //压缩尺寸
        quality = 0.6, // 压缩质量
        canvas = document.createElement('canvas'),
        drawer = canvas.getContext('2d')
      let base64 = ''
      // 判断原图片大小
      if (originWidth > 1000) {
        let targetWidth = maxWidth
        let targetHeight = (1000 * originHeight) / originWidth
        canvas.width = targetWidth
        canvas.height = targetHeight
        drawer.drawImage(img, 0, 0, canvas.width, canvas.height)
        base64 = canvas.toDataURL('image/jpeg', quality) // 压缩后的base64图片
      } else {
        base64 = img.src
      }
      //压缩完成上传图片  base64转blob
      let file = this.dataURLtoBlob(base64)
      // blob转file
      let fileCompressed = this.blobToFile(file, imgName)
      this.uploadFinalFile(fileCompressed, fileOrigin)
    },
    uploadFinalFile(file, fileOrigin) {
      let formData = new FormData()
      formData.append('file', file, file.name)
      uploadFile(formData)
        .then((res) => {
          this.fileStatusSet(fileOrigin, 'done', '上传成功', res.data.url)
          // this.form.insuranceApplicationFile = res.data.url
          console.log(this.form, 'this.form')
        })
        .catch(() => {
          this.fileStatusSet(fileOrigin, 'failed', '上传失败')
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
body{
  width: 100%
  .box{
    height: 100vh
    overflow-y: scroll
    height: 100%
    // padding: 30px 0
    .tips{
      margin: 30px
      font-size: 26px
    }
    .confirm{
        margin: 30px auto
        text-align: center
        .confirm-btn{
          // border-radius: 20px
          width: 720px
        }
      }
  }
  .van-popup{
    width: 100vw
    height: 100vh
  }
  .choose-box{
    width: 100%
    height: 100%
    text-align: center
    padding-top: 400px
    .title{
      font-size: 32px
      font-weight: bold
      margin: 0 0 60px 0
    }
    .item{
      color: #fff
      width: 500px
      line-height: 100px
      margin: 20px auto
      background: #E99D42
    }
  }
}

// 上传组件样式优化
.upload-section
  width: 100%

  .custom-uploader
    width: 100%

    // 自定义上传按钮样式
    /deep/ .van-uploader__wrapper
      display: flex
      flex-wrap: wrap
      gap: 10px

    /deep/ .van-uploader__upload
      width: 100px
      height: 100px
      border: 2px dashed #E99D42
      border-radius: 8px
      background: #fafafa
      display: flex
      align-items: center
      justify-content: center
      position: relative
      transition: all 0.3s ease

      &:hover
        border-color: #d4a574
        background: #f5f5f5
        transform: translateY(-2px)
        box-shadow: 0 4px 12px rgba(233, 157, 66, 0.2)

      &:active
        transform: translateY(0)
        box-shadow: 0 2px 6px rgba(233, 157, 66, 0.3)

    // 预览图片样式
    /deep/ .van-uploader__preview
      width: 100px
      height: 100px
      border-radius: 8px
      overflow: hidden
      position: relative
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1)

      .van-uploader__preview-image
        width: 100%
        height: 100%
        object-fit: cover

      .van-uploader__preview-delete
        position: absolute
        top: -8px
        right: -8px
        width: 20px
        height: 20px
        background: #ff4757
        border-radius: 50%
        display: flex
        align-items: center
        justify-content: center
        color: white
        font-size: 12px
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)

        &:hover
          background: #ff3742
          transform: scale(1.1)

  .upload-placeholder
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    height: 100%
    padding: 10px
    text-align: center

    .upload-text
      font-size: 18px
      color: #E99D42
      font-weight: 500
      margin: 8px 0 4px 0

    .upload-hint
      font-size: 16px
      color: #999
      line-height: 1.2

  .download-section
    margin-top: 15px
    padding: 12px 16px
    background: linear-gradient(135deg, #fff8f0 0%, #fef5e7 100%)
    border: 1px solid #f0e6d2
    border-radius: 8px
    position: relative

    &::before
      content: ''
      position: absolute
      left: 0
      top: 0
      bottom: 0
      width: 4px
      background: #E99D42
      border-radius: 2px 0 0 2px

    .download-text
      display: flex
      align-items: center
      font-size: 20px
      color: #666
      line-height: 1.4

      .download-link
        color: #E99D42
        font-weight: 500
        text-decoration: underline
        cursor: pointer
        margin: 0 4px
        transition: color 0.3s ease

        &:hover
          color: #d4a574
          text-decoration: none

        &:active
          color: #c4965a
</style>
